import React, { Component } from 'react';
import Web3 from 'web3';
import ConditionedComponent from 'components/ConditionedComponent.js';
import '../../SamplePacks.css';
import {web3} from 'decentralized/web3.js';

class SequenceListComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.getDate();
        this.getName();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.sequence.id !== nextProps.sequence.id) {
            this.getDate(nextProps.sequence);
        }
        if (this.props.showingEdits !== nextProps.showingEdits ||
            this.props.sequence.id !== nextProps.sequence.id) {
            this.getName(nextProps.sequence);
        }
        return true;
    }

    
    async getName(sequence=this.props.sequence) {
        if (!navigator.onLine) {
            this.setState({name: 'offline'});
            return;
        }
        let user = await this.getUser(sequence);
        let name = await this.props.ethereum.users.getUserName(user);
        name = name === '' ? user : name;
        this.setState({
            name: name
        }); 
    }

    async getDate(sequence=this.props.sequence) {
        if (!navigator.onLine) {
            this.setState({date: 'offline'});
            return;
        }
        try {
            let block = await web3.eth.getBlock(sequence.blockNumber);
            let date = new Date(block.timestamp * 1000).toLocaleString();
            this.setState({date: date});
        } catch (e) {
            this.setState({date: 'unknown'});
        }
    }

    async getUser(sequence=this.props.sequence) {
        let edits = await this.props.getEditsForSequence(sequence);
        return this.props.showingEdits ? sequence.user : edits[edits.length - 1].user;
    }

    async onClickName(sequence=this.props.sequence) {
        let user = await this.getUser(sequence);
        this.props.onClickName(user);
    }

    render() {
        let className = this.props.odd ? 'sample-pack-item odd' : 'sample-pack-item';
        return (
            <div className={className}>
              <div className="sequence-name-and-user">
                <div className="sample-pack-name" onClick={() => this.props.onClick()}>{this.props.sequence.name}</div>
                  <div
                    onClick={() => this.onClickName()}
                    className="sample-pack-user-name"> {this.state.name}</div>
              </div>
              <span className="sample-pack-date">{this.state.date}</span> 
              {this.props.sequence.edits > 0 ?
                  <span
                    onClick={this.props.onClickEdits}
                    className="sample-pack-edits">{this.props.sequence.edits} edits</span>  : ''}
                  <ConditionedComponent condition={this.props.sequence.publicKey}>
                    <span className="private-sequence">Private</span>
                    <span className="private-sequence share-sequence" onClick={this.props.shareSequence}>Share</span>
                  </ConditionedComponent>
            </div>
        );
    }
}

export default SequenceListComponent;
